export const initialGridColumns = [
  { value: true, label: 'Car ID', key: 'vehicleInternalId' },
  { value: true, label: 'SKU', key: 'skuId' },
  { value: true, label: 'Plate', key: 'plate' },
  { value: true, label: 'Sourcing Type', key: 'sourcingType' },
  { value: true, label: 'Brand', key: 'brand' },
  { value: true, label: 'Model', key: 'model' },
  {
    value: true,
    label: 'Edition',
    key: 'edition',
  },
  {
    value: true,
    label: 'VIN',
    key: 'vin',
  },
  { value: true, label: 'Fuel Type', key: 'fuelType' },
  { value: true, label: 'Engine Type', key: 'engineType' },
  { value: true, label: 'Transmission', key: 'transmission' },
  { value: true, label: 'Color', key: 'color' },
  { value: true, label: 'Price', key: 'price' },
  { value: true, label: '12 Months Price', key: 'price12' },
  { value: true, label: '24 Months Price', key: 'price24' },
  { value: true, label: '36 Months Price', key: 'price36' },
  { value: true, label: 'Reservation Type', key: 'reservationType' },
  { value: true, label: 'Location', key: 'location' },
  { value: true, label: 'Status', key: 'status' },
  { value: true, label: 'Stage', key: 'procurementStageId' },
  { value: true, label: 'ERFUDD', key: 'erfudd' },
  { value: true, label: 'Return Date', key: 'returnDate' },
  {
    value: true,
    label: 'Planned Downpayment Date',
    key: 'plannedDownpaymentDate',
  },
  { value: true, label: 'Idle Days', key: 'idleDays' },
  { value: true, label: 'WWW link', key: 'link' },
  { value: true, label: 'WWW Availability', key: 'wwwAvailability' },
  { value: true, label: 'Vehicle Category Class', key: 'categoryClass' },
  { value: true, label: 'Condition', key: 'condition' },
  { value: true, label: 'Defleet Priority', key: 'defleetPriority' },
  { value: true, label: 'Month of Defleet', key: 'monthOfDefleet' },
];

export const AVAILABILITY_TABLE_TABS = {
  all: {
    label: 'ALL',
    key: '',
  },
  predel: {
    label: 'PREDEL',
    key: 'predel',
  },
  idle: {
    label: 'IDLE',
    key: 'idle',
  },
  sales: {
    label: 'SALES',
    key: 'sales',
  },
};
